import { QueryStatus, useQuery } from '@tanstack/react-query';

import { fetchLocations } from './fetchLocations';
import { Location } from '../CommonTypes';
import useSite from './useSite';

const useLocations = (svgUrl: string | undefined, localFile?: string) => {
  const [site] = useSite();

  if (localFile && process.env.NODE_ENV === 'development') {
    // const file = svgUrl?.match(/[^/]+\.svg(?=$|[?#])/i)?.[0];
    svgUrl = `/svg/${site.company}/${site.sitename}/views/${localFile}`;
  }

  const results = useQuery({
    queryKey: ['svgUrl', svgUrl],
    queryFn: () => fetchLocations(svgUrl),
  });

  return [results?.data?.viewBox ?? '', results?.data?.paths ?? [], results.status] as [
    string,
    Location[],
    QueryStatus,
  ];
};

export { useLocations };
